(function(){
  'use strict'; 
  angular.module('Directives').directive('bbaTimeDurationInput', bbaTimeDurationInput); 
  bbaTimeDurationInput.$inject = [
    '$filter'
  ]; 

  function bbaTimeDurationInput(
    $filter
  ){
    return {
      restrict: 'E', 
      templateUrl: '/templates/directives/form-components/bba-time-duration-input.html',
      require: ['^form','ngModel'],
      scope: {
        ngModel: '='
      }, 
      link: bbaTimeDurationInputLink
    }

    function bbaTimeDurationInputLink($scope, $attrs, $elems) {
      $scope.hourLabel = 'HR'; 
      $scope.minuteLabel = 'MIN';
      $scope.secondsLabel = 'SEC';

      $scope.formName = $scope.ngModel.id.replace(' ', '-').toLowerCase();
      $scope.onChange = onChange;
      
      init(); 
      function init() {
        const timeStr = $filter('bbaTimeConverter')($scope.ngModel.value).split(':');
        $scope.hour = Number(timeStr[0]);
        $scope.mins = Number(timeStr[1]); 
        $scope.sec  = Number(timeStr[2]);
        generateSecondsAndMins();
      }
      
      function generateSecondsAndMins() {
        $scope.minuteSecondsOptions = []; 
        for(var i = 0; i < 61; i++) {
          $scope.minuteSecondsOptions.push(i);
        }
      }

      function onChange() {
        const hours = $scope.hour || 0; 
        const mins  = $scope.mins ? Number($scope.mins) : 0;
        const seconds = $scope.sec ? Number($scope.sec) : 0;
        $scope.ngModel.value = convertValuesToSeconds(hours, mins, seconds);
      }

      function convertValuesToSeconds(hours, mins, seconds) {
        const secondsInOneHour = 3600; 
        const secondsInOneMinute = 60; 

        const hoursToSeconds = hours * secondsInOneHour; 
        const minsToSeconds = mins * secondsInOneMinute; 
        return (hoursToSeconds + minsToSeconds) + seconds;
      }
    }
  }
})()


// WEBPACK FOOTER //
// ./js/directives/form-components/bbaTimeDurationInput.js